var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -370.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/Contacts",
    transform: "translate(3498.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.489,16 L30.727,16 L20,25.050625 L14.178,20.1390625 L17.489,16 Z M20.668,27.0090625 L32,17.4484375 L32,27.25 C32,29.3209375 30.209,31 28,31 L8,31 L8,25.10875 C8.3,25.271875 8.638,25.3675 8.994,25.3675 C9.624,25.3675 10.217,25.09 10.594,24.6175 L12.973,21.6446875 L19.33,27.0090625 C19.521,27.169375 19.76,27.25 20,27.25 C20.238,27.25 20.478,27.169375 20.668,27.0090625 L20.668,27.0090625 Z M5.25,9.4375 C5.25,7.4959375 6.928,5.921875 9,5.921875 C11.071,5.921875 12.75,7.4959375 12.75,9.4375 C12.75,11.3790625 11.071,12.953125 9,12.953125 C6.928,12.953125 5.25,11.3790625 5.25,9.4375 L5.25,9.4375 Z M15.968,14.7765625 C17.237,13.3225 18,11.4634375 18,9.4375 C18,4.7771875 13.97,1 9,1 C4.029,1 0,4.7771875 0,9.4375 C0,11.4128125 0.726,13.22875 1.939,14.6659375 L8.994,23.4925 L15.968,14.7765625 Z",
    id: 108
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareContacts);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-contacts.b4e382ae.svg";
export { ForwardRef as ReactComponent };